"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CONFIG = void 0;
var he_1 = __importDefault(require("he"));
var media_config_1 = require("../interfaces/media-config");
var timespan_1 = __importDefault(require("./timespan"));
exports.DEFAULT_CONFIG = {
    playResX: 1920,
    playResY: 1080,
    font: "Verdana",
    fontSize: 72,
    colorPrimary: "FFFFFF",
    colorSecondary: "0000FF",
    colorOutline: "000000",
    colorBack: "000000",
    bold: 0,
    italic: 0,
    underline: 0,
    strikeOut: 0,
    scaleX: 100,
    scaleY: 100,
    spacing: 0,
    angle: 0,
    borderStyle: 3,
    outline: 10,
    shadow: 0.5,
    alignment: 2,
    marginL: 100,
    marginR: 100,
    marginV: 100,
    encoding: 0,
    showWatermark: true,
    hasBackground: true,
    backgroundStyle: media_config_1.BackgroundStyle.Background
};
function assHeader(assConfig) {
    var _a;
    var playResX = assConfig.playResX, playResY = assConfig.playResY;
    var header = [
        "[Script Info]",
        "; Script generated by Subly",
        "ScriptType: v4.00+",
        "WrapStyle: 0",
        "ScaledBorderAndShadow: Yes",
        "YCbCr Matrix: None",
        "PlayResX: " + playResX,
        "PlayResY: " + playResY,
        "",
        "[V4+ Styles]",
        "Format: Name, Fontname, Fontsize, PrimaryColour, SecondaryColour, OutlineColour, BackColour, Bold, Italic, Underline, StrikeOut, ScaleX, ScaleY, Spacing, Angle, BorderStyle, Outline, Shadow, Alignment, MarginL, MarginR, MarginV, Encoding",
        generateStyle(assConfig, "Default")
    ];
    if ((_a = assConfig.headline) === null || _a === void 0 ? void 0 : _a.visible) {
        header.push(generateStyle(assConfig.headline.style, "Title"));
    }
    header.push("", "[Events]", "Format: Layer, Start, End, Style, Actor, MarginL, MarginR, MarginV, Effect, Text");
    return header.join("\n") + "\n";
}
var generateStyle = function (styles, 
// playResX = 1920,
name) {
    if (name === void 0) { name = "Default"; }
    if (!styles) {
        return "";
    }
    var font = styles.font, fontSize = styles.fontSize, bold = styles.bold, italic = styles.italic, underline = styles.underline, strikeOut = styles.strikeOut, scaleX = styles.scaleX, scaleY = styles.scaleY, spacing = styles.spacing, angle = styles.angle, alignment = styles.alignment, marginL = styles.marginL, marginR = styles.marginR, marginV = styles.marginV, encoding = styles.encoding, hasBackground = styles.hasBackground, subtitles = styles.subtitles;
    var outline = styles.outline, borderStyle = styles.borderStyle, colorOutline = styles.colorOutline, shadow = styles.shadow;
    var colorPrimary = normalizeColor(styles.colorPrimary);
    var colorSecondary = normalizeColor(styles.colorSecondary);
    var colorBack = normalizeColor(styles.colorBack);
    if (hasBackground) {
        colorOutline = colorBack;
        outline = 10;
        borderStyle = 3;
    }
    else {
        borderStyle = 1;
    }
    if (hasBackground && (subtitles === null || subtitles === void 0 ? void 0 : subtitles.fullWidth)) {
        outline = 0;
        shadow = 0;
        borderStyle = 1;
    }
    // TODO: Experiment with dynamic font sizes
    // fontSize = calculateFontSize(fontSize, playResX);
    return "Style: " + name + "," + font + "," + fontSize + ",&H" + colorPrimary + ",&H" + colorSecondary + ",&H" + colorOutline + ",&H" + colorBack + "," + bold + ", " + italic + ", " + underline + ", " + strikeOut + ", " + scaleX + ", " + scaleY + ", " + spacing + ", " + angle + ", " + borderStyle + ", " + outline + ", " + shadow + ", " + alignment + ", " + marginL + ", " + marginR + ", " + marginV + ", " + encoding;
};
//src: <ruby>明日<rt>あした</tr></ruby>また<ruby>会<rt>あう</rt></ruby><ruby>時<rt>とき</rt></ruby>
//tgt: {\k}明日|あした{\k}また{\k}会|あう{\k}時|とき
//ref: http://docs.aegisub.org/manual/Furigana_karaoke
function parseTreeRuby(tree) {
    var ret = "{\\k}";
    tree.children.forEach(function (item) {
        if (item.type === "text") {
            ret += item.value;
        }
        else if (item.type === "object") {
            if (item.name === "rt") {
                ret += "|" + parseTreeInner(item, true).text;
                ret += "{\\k}";
            }
        }
    });
    return ret;
}
function parseTreeInner(tree, noTag) {
    var nodes = tree.children;
    var ret = { text: "" };
    if (tree.name === "ruby") {
        ret.text += parseTreeRuby(tree);
        ret.style = "Ruby";
    }
    else {
        if (tree.name === "v") {
            ret.voice = tree.value;
        }
        nodes.forEach(function (item) {
            if (item.type === "object") {
                var temp = parseTreeInner(item);
                ret.text += temp.text;
                ret.style = temp.style;
                if (ret.voice === undefined) {
                    ret.voice = temp.voice;
                }
            }
            else {
                ret.text += item.value;
            }
        });
        if (tree.name !== undefined && noTag === undefined) {
            if (tree.name !== "v") {
                ret.text =
                    "{\\" + tree.name + "1}" + ret.text + "{\\" + tree.name + "0}";
            }
        }
    }
    return ret;
}
function parseSegment(line) {
    var ret = parseTreeInner(line.tree);
    if (ret.voice === undefined) {
        ret.voice = "";
    }
    if (ret.style === undefined) {
        ret.style = "Default";
    }
    ret.text = he_1.default.decode(ret.text).replace(/\n/g, "\\N");
    ret.begin = timespan_1.default(line.startTime);
    ret.end = timespan_1.default(line.endTime);
    return ret;
}
// TODO: Experiment with dynamic font sizes
// function calculateFontSize(fontSize: number, playResX: number): number {
//   const defaultRatio = 1920 / 72;
//   return Math.floor(fontSize * (playResX / fontSize / defaultRatio));
// }
// To be backward compatible, old saved colors are RGB and new colors
// are RGBA, so we need to prefix the alpha hex if it doesn't have one
var normalizeColor = function (color) {
    return color.length > 6 ? color : "00" + color;
};
exports.default = { assHeader: assHeader, parseSegment: parseSegment };
//# sourceMappingURL=subtitle.text.js.map